// CMS tour-points endpoints used by mode-tool sync/list/delete flows.
const tourPointsEndpoints = {
  base: '/v1/cms/tour-points',
  drivingBase: '/v1/cms/tour-points/driving',
  drivingByTourType: (tourTypeId) => `/v1/cms/tour-points/driving/${tourTypeId}`,
  drivingByTourTypePoint: (tourTypeId, pointNumber) => `/v1/cms/tour-points/driving/${tourTypeId}/${pointNumber}`,
  walkingBase: '/v1/cms/tour-points/walking',
  walkingByTour: (tourId) => `/v1/cms/tour-points/walking/${tourId}`,
  walkingByRouteType: (routeTypeId) => `/v1/cms/tour-points/walking/${routeTypeId}`,
  randomBase: '/v1/cms/tour-points/random',
  randomByTour: (tourId) => `/v1/cms/tour-points/random/${tourId}`,
  allByTour: (tourId) => `/v1/cms/tour-points/all/${tourId}`,
  byTourType: (tourTypeId) => `/v1/cms/tour-points/${tourTypeId}`,
  byTourTypePoint: (tourTypeId, pointNumber) => `/v1/cms/tour-points/${tourTypeId}/${pointNumber}`
};

export default tourPointsEndpoints;
